// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eYN7","colBig":"styles_colBig__UCCBB","colSmall":"styles_colSmall__26cbs","shopifyNameWrapper":"styles_shopifyNameWrapper___O0gI"};